import React from 'react';
import { motion } from 'framer-motion';

export const GlassCard = ({ children, className = '', onClick, hoverEffect = true }) => {
  return (
    <motion.div
      whileHover={hoverEffect ? { scale: 1.02, y: -5 } : {}}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      className={`glass card-hover ${className}`}
      onClick={onClick}
    >
      {children}
    </motion.div>
  );
};